<template>
	<div class="guided-tutorials-menu" :class="{ 'is-open': isOpen, 'is-on-left': isOnLeft, 'is-nudge-top': isNudgeTop }">
		<OnBoardingBuildYourFirstItem
			v-for="subStep in guidedTutorialsSteps"
			class="mt-4"
			v-on="$listeners"
			:key="subStep.id"
			:subStepDetails="subStep"
			:class="{ 'not-active-sub-step': subStep.isCompleted }"
			@startTutorial="startTutorial"
		/>
	</div>
</template>

<script>
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { setIsGuidedTutorialOn } from '@/store/modules/onboarding/actions';
import { guidedTutorials } from '@/store/modules/onboarding/getters';

import { reformatGuidedTutorials } from '@/components/Onboarding/on-boarding-service.js';

import OnBoardingBuildYourFirstItem from '@/components/Onboarding/OnBoardingFlow/OnBoardingSection/OnBoardingSteps/GetBuilding/OnBoardingBuildYourFirstItem.vue';

export default {
	name: 'GuidedTutorialsMenu',
	components: {
		OnBoardingBuildYourFirstItem,
	},
	props: {
		isOpen: { type: Boolean },
		isOnLeft: { type: Boolean },
		isNudgeTop: { type: Boolean },
	},
	computed: {
		...mapGettersShorthand({ guidedTutorials }),
		isButtonOnTheLeftSide() {
			const routes = ['Feature'];
			return routes.includes(this.$route.name);
		},
		guidedTutorialsSteps() {
			return reformatGuidedTutorials(this.guidedTutorials);
		},
	},
	methods: {
		...mapActionsShorthand({ setIsGuidedTutorialOn }),
		startTutorial() {
			this.setIsGuidedTutorialOn(true);
			this.$emit('setIsOpen', false);
		},
	},
};
</script>

<style lang="scss" scoped>
@import './in-app-help-mixin.scss';
@import './in-app-help-menu-mixin.scss';

.guided-tutorials-menu {
	.page-wrapper {
		padding: 0 40px;
	}

	@include open-close-behaviour();
	@include in-app-help-menu-styles();
}
</style>
